import styled from '@emotion/styled'
import { css } from '@emotion/react'
import React from 'react'

const HeadingStyle = styled.h4`
  color: #ffffff;
  font-size: 60px;
  font-family: 'haettenschweiler';
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: ${props => props.mb};
  margin-top: ${props => props.mt};
`

export const Heading = (props) => {
  return (
    <HeadingStyle className='mr-3' mb={props.mb ? props.mb : '1.5rem'} mt={props.mt ? props.mt : '0rem'}>{props.children}</HeadingStyle>
  )
}
